import React, { useState, useEffect } from "react";
import Toastify from "~/components/Toastify/index";
import { apiSuporte } from "~/services/api";
import {
    ButtonAgendamentoSucesso,
    ButtonInfo,
    ButtonSucess,
    DivContentElements,
    DivHorario,
    DivHorariosDisponiveis,
    DivMainAgendamentoSucesso,
    DivMainHorarioAgendamentoTreinamento,
    DivMainHorariosLivres,
    DivMainPopupHorarios,
    DivTitulo,
    H1TituloHorarios,
    InputText,
    PAgendamentoSucesso,
    PopupHorarios,
    SelectTipoAgendamento,
    SpanBotaoClose,
    SpanHorarioSelecionado,
    SpanTitulo,
} from "./stylesAgendamentoTreinamento";
import Loading from "~/components/loading/loading";
import imagemSucesso from "~/assets/images/icons8-happy-64.png";
export default function AgendamentoTreinamento() {
    //#region constantes para debug desenvolvimento

    const dadosApiBuscaEmailAssinante = {
        Nome: "Brabo",
        Email: "info@medx.med.br",
        IdCliente: 6869,
    };

    //#endregion
    //#region declaração dos estados
    const [horariosLivres, setHorariosLivres] = useState([]);
    const [display, setDisplay] = useState("none");
    const [dadosAgendamento, setDadosAgendamento] = useState({
        IdUsuario: "",
        Email: "",
        EmailAssinante: "",
        Nome: "",
        Telefone: "",
        Data: "",
        DataSelecionada: "",
        NomeAssinante: "",
        IdCliente: "",
        TipoAgendamento: "",
    });
    const [mostraParte2Form, setMostraParte2Form] = useState(false);
    const [mostraParte3Form, setMostraParte3Form] = useState(false);
    const [mostrarButtonInfo, setMostrarButtonInfo] = useState(true);
    const [openPopupHorarios, setOpenPopupHorarios] = useState(false);
    const [openPopupAgendamentoSucesso, setOpenPopupAgendamentoSucesso] =
        useState(false);
    //#endregion
    function montaHorario(horario) {
        let data = new Date(horario);

        let dia = data.getDate();
        if (dia.toString().length < 2) {
            dia = "0" + dia;
        }
        let mes = data.getMonth() + 1;
        if (mes.toString().length < 2) {
            mes = "0" + mes;
        }
        let ano = data.getFullYear();

        let hora = data.getHours();
        if (hora.toString().length < 2) {
            hora = "0" + hora;
        }

        let minutos = data.getMinutes();
        if (minutos.toString().length < 2) {
            minutos = "0" + minutos;
        }
        return dia + "/" + mes + "/" + ano + " " + hora + ":" + minutos;
    }

    function removeLetrasCaractEspeciais(string) {
        return string.replace(/[^\d]/g, "");
    }

    function verificaData(data) {
        let ano = new Date(data).getFullYear();
        let anoAtual = new Date().getFullYear();
        if (ano == anoAtual) {
            console.log("achou ano");
        } else {
            console.log("não achou ano");
        }
        setDadosAgendamento({ ...dadosAgendamento, Data: data });
    }

    function organizaDataRequest(data) {
        let dataOrganizada = new Date(data);
        let diaDataOrganizada = dataOrganizada.getDate() + 1;
        if (diaDataOrganizada.toString().length == 1) {
            diaDataOrganizada = "0" + diaDataOrganizada;
        }
        let mesDataOrganizada = dataOrganizada.getMonth() + 1;
        if (mesDataOrganizada.toString().length == 1) {
            mesDataOrganizada = "0" + mesDataOrganizada;
        }
        let anoDataOrganizada = dataOrganizada.getFullYear();

        return `${anoDataOrganizada}-${mesDataOrganizada}-${diaDataOrganizada}`;
    }

    function abrePopupHorarios() {
        // if (dadosAgendamento.Data == "") {
        //     Toastify.warning("Selecione a data.");
        //     return;
        // }
        if (dadosAgendamento.Nome == "") {
            Toastify.warning(
                "Por favor informe o nome de quem receberá o treinamento."
            );
            return null;
        }
        if (dadosAgendamento.Telefone == "") {
            Toastify.warning("Por favor informe o telefone para contato.");
            return null;
        }
        if (dadosAgendamento.Email == "") {
            Toastify.warning("Por favor informe o seu email.");
            return null;
        }
        if (dadosAgendamento.TipoAgendamento == "") {
            Toastify.warning("Por favor informe o tipo do treinamento.");
            return null;
        }
        setOpenPopupHorarios(true);
        carregaHorariosLivres(organizaDataRequest(new Date()));
    }

    function buscaEmailAssinanteKeyPress(event) {
        if (event.key == "Enter") {
            buscaEmailAssinante(dadosAgendamento.EmailAssinante);
        } else {
            return;
        }
    }

    function selecionaData(dataHorario) {
        setDadosAgendamento({
            ...dadosAgendamento,
            DataSelecionada: dataHorario.replace("T", " "),
        });
        setOpenPopupHorarios(false);
        setMostrarButtonInfo(false);
        setMostraParte3Form(true);
    }

    function agrupaHorariosPorData(arrayHorarios) {
        const groups = arrayHorarios.reduce((groups, game) => {
            const date = game.Inicio.split("T")[0];
            if (!groups[date]) {
                groups[date] = [];
            }
            groups[date].push(game);
            return groups;
        }, {});
        return groups;
    }

    function MontaGridHorarios(arrayHorarios) {
        const dados = agrupaHorariosPorData(arrayHorarios);

        return Object.keys(dados).map((item) => {
            return (
                <div>
                    <H1TituloHorarios>
                        {MontaTituloHorario(item)}
                    </H1TituloHorarios>
                    <DivHorariosDisponiveis>
                        {Object.values(dados[item]).map(
                            (newItem, index, array) => {
                                const horario = MontaHorariosGris(
                                    newItem.Inicio
                                );
                                if (horario) {
                                    return (
                                        <DivHorario
                                            onClick={() =>
                                                selecionaData(newItem.Inicio)
                                            }
                                        >
                                            {horario}
                                        </DivHorario>
                                    );
                                } else {
                                    return null;
                                }
                            }
                        )}
                    </DivHorariosDisponiveis>
                </div>
            );
        });
    }

    function MontaTituloHorario(data) {
        const arrayData = data.split("-");
        const dia = arrayData[2];
        const mes = arrayData[1];
        const ano = arrayData[0];
        return `${dia}/${mes}/${ano}`;
    }

    function MontaHorariosGris(data) {
        const arrayData = data.split("T");
        const horarioRaw = arrayData[1];
        const horarioFormatado = horarioRaw.substring(0, 5);
        if (horarioFormatado == "12:00") {
            return null;
        }
        return horarioFormatado;
    }

    async function buscaEmailAssinante(email) {
        try {
            if (email == "") {
                return;
            }
            if (
                !(
                    email.includes("@") &&
                    (email.includes(".com") || email.includes(".br"))
                )
            ) {
                Toastify.warning("Insira um email válido.");
                return;
            }
            setDisplay("flex");
            const requestGetEmailAssinante = await apiSuporte.get(
                `suporte/VerificaEmailAssinante?email=${email}`
            );
            if (requestGetEmailAssinante.status == 200) {
                const data = requestGetEmailAssinante.data;
                setDadosAgendamento({
                    ...dadosAgendamento,
                    NomeAssinante: data.Nome,
                    EmailAssinante: data.Email,
                    IdCliente: data.IdCliente,
                    IdUsuario: 42,
                });
                setMostraParte2Form(true);
                setDisplay("none");
            }
        } catch (error) {
            if (error.request.status == 404) {
                Toastify.error("Email não encontrado.");
                setDisplay("none");
                return;
            }
            if (error.request.response) {
                let response = JSON.parse(error.request.response);
                if (response.Message) {
                    Toastify.error(response.Message);
                    setDisplay("none");
                    return null;
                }
            }
            Toastify.error("Não foi possível buscar email de assinante.");
            setDisplay("none");
        }
    }

    async function carregaHorariosLivres(data) {
        try {
            setDisplay("flex");
            const requestGetHorariosLivres = await apiSuporte.get(
                `suporte/GetHorariosLivresTreinamentoSuporte?data=${data}`
            );
            if (requestGetHorariosLivres.status == 200) {
                setHorariosLivres(requestGetHorariosLivres.data);
                setDisplay("none");
            } else {
                Toastify.error("Erro ao carregar horários.");
                setDisplay("none");
            }
        } catch (error) {
            console.log(error);
            Toastify.error("Não foi possível carregar horários livres.");
            setDisplay("none");
        }
    }

    function calculaFinal(inicio) {
        let data = new Date(inicio);

        let dia = data.getDate();
        if (dia.toString().length < 2) {
            dia = "0" + dia;
        }
        let mes = data.getMonth() + 1;
        if (mes.toString().length < 2) {
            mes = "0" + mes;
        }
        let ano = data.getFullYear();

        let hora = data.getHours() + 1;
        if (hora.toString().length < 2) {
            hora = "0" + hora;
        }

        let minutos = data.getMinutes();
        if (minutos.toString().length < 2) {
            minutos = "0" + minutos;
        }
        return ano + "-" + mes + "-" + dia + " " + hora + ":" + minutos;
    }

    function resetInformacoes() {
        setDadosAgendamento({
            IdUsuario: "",
            Email: "",
            EmailAssinante: "",
            Nome: "",
            Telefone: "",
            Data: "",
            DataSelecionada: "",
            NomeAssinante: "",
            IdCliente: "",
            TipoAgendamento: "",
        });
        setMostraParte2Form(false);
        setMostraParte3Form(false);
        setMostrarButtonInfo(true);
        setOpenPopupAgendamentoSucesso(false);
    }

    async function salvarAgendamento() {
        try {
            setDisplay("flex");
            const objAgendamento = {
                IdUsuario: dadosAgendamento.IdUsuario,
                Inicio: dadosAgendamento.DataSelecionada.replace("T", " "),
                Final: calculaFinal(dadosAgendamento.DataSelecionada),
                Descricao:
                    dadosAgendamento.Nome +
                    " " +
                    dadosAgendamento.Telefone +
                    " " +
                    dadosAgendamento.TipoAgendamento +
                    " " +
                    dadosAgendamento.EmailAssinante +
                    "[Agendamento Online]",
                TipoAgendamento: dadosAgendamento.TipoAgendamento,
                IdCliente: dadosAgendamento.IdCliente,
                Email: dadosAgendamento.Email,
                Nome: dadosAgendamento.Nome,
            };
            const requestSalvarAgendamento = await apiSuporte.post(
                `suporte/InsertAgendamentoTreinamento`,
                objAgendamento
            );
            if (requestSalvarAgendamento.status == 200) {
                Toastify.success("Agendamento feito com sucesso.");
                setOpenPopupAgendamentoSucesso(true);
                setDisplay("none");
            }
        } catch (error) {
            console.log(error.request);
            setDisplay("none");
            Toastify.error("Não foi possível salvar agendamento.");
        }
    }

    useEffect(() => {
        //carregaHorariosLivres("2022-02-17");
    }, []);
    return (
        <DivMainHorarioAgendamentoTreinamento>
            <div style={{ marginBottom: "12px" }}>
                <h1>Agendamento de treinamento do sistema Online</h1>
            </div>
            <DivContentElements>
                <SpanTitulo>Informe o email de assinante:</SpanTitulo>
                <InputText
                    type="text"
                    placeholder="Email de assinante"
                    value={dadosAgendamento.EmailAssinante}
                    //onBlur={(event) => buscaEmailAssinante(event.target.value)}
                    onChange={(event) =>
                        setDadosAgendamento({
                            ...dadosAgendamento,
                            EmailAssinante: event.target.value,
                        })
                    }
                    onKeyPress={(event) => buscaEmailAssinanteKeyPress(event)}
                    disabled={mostraParte2Form}
                />
                <ButtonInfo
                    mostrar={!mostraParte2Form}
                    style={{ marginBottom: "12px" }}
                    onClick={() =>
                        buscaEmailAssinante(dadosAgendamento.EmailAssinante)
                    }
                >
                    Prosseguir
                </ButtonInfo>
                {mostraParte2Form ? (
                    <>
                        <SpanTitulo>
                            Informe o nome de quem receberá o treinamento*:
                        </SpanTitulo>
                        <InputText
                            type="text"
                            placeholder="Nome de quem receberá o treinamento*."
                            value={dadosAgendamento.Nome}
                            onChange={(event) =>
                                setDadosAgendamento({
                                    ...dadosAgendamento,
                                    Nome: event.target.value,
                                })
                            }
                        />
                        <SpanTitulo>
                            Informe o telefone para contato*:
                        </SpanTitulo>
                        <InputText
                            type="text"
                            placeholder="Telefone para contato*"
                            value={dadosAgendamento.Telefone}
                            onChange={(event) =>
                                setDadosAgendamento({
                                    ...dadosAgendamento,
                                    Telefone: removeLetrasCaractEspeciais(
                                        event.target.value
                                    ),
                                })
                            }
                        />
                        <SpanTitulo>
                            Informe o email para receber as instruções do
                            treinamento*:
                        </SpanTitulo>
                        <InputText
                            type="text"
                            placeholder="Email para receber as intruções do treinamento*"
                            value={dadosAgendamento.Email}
                            onChange={(event) =>
                                setDadosAgendamento({
                                    ...dadosAgendamento,
                                    Email: event.target.value,
                                })
                            }
                        />
                        <div style={{ display: "none" }}>
                            <SpanTitulo>Informe a data:</SpanTitulo>
                            <InputText
                                type="date"
                                min={`${new Date().getFullYear()}-01-01`}
                                max={`${new Date().getFullYear()}-12-01`}
                                value={dadosAgendamento.Data}
                                onChange={(event) =>
                                    verificaData(event.target.value)
                                }
                            />
                        </div>
                        <SpanTitulo>Motivo de agendamento:</SpanTitulo>
                        <SelectTipoAgendamento
                            value={dadosAgendamento.TipoAgendamento}
                            onChange={(event) =>
                                setDadosAgendamento({
                                    ...dadosAgendamento,
                                    TipoAgendamento: event.target.value,
                                })
                            }
                        >
                            <option value="">Selecione opção</option>
                            <option value="Secretaria">Secretária</option>
                            <option value="Medico">Médico</option>
                            <option value="Financeiro">Financeiro</option>
                        </SelectTipoAgendamento>
                        <SpanHorarioSelecionado mostrar={!mostrarButtonInfo}>
                            Horario selecionado:{" "}
                            {montaHorario(dadosAgendamento.DataSelecionada)}
                        </SpanHorarioSelecionado>
                        <ButtonInfo
                            mostrar={mostrarButtonInfo}
                            onClick={() => abrePopupHorarios()}
                        >
                            Buscar próximos horários disponíveis
                        </ButtonInfo>
                    </>
                ) : (
                    ""
                )}
                {mostraParte3Form ? (
                    <>
                        <ButtonSucess onClick={() => salvarAgendamento()}>
                            Confirmar Agendamento
                        </ButtonSucess>
                    </>
                ) : (
                    ""
                )}
            </DivContentElements>
            <Loading mostrar={display} />
            <PopupHorarios mostraPopup={openPopupHorarios}>
                <DivMainPopupHorarios>
                    <DivTitulo>
                        <h1>Horarios livres</h1>
                        <SpanBotaoClose
                            onClick={() => setOpenPopupHorarios(false)}
                        >
                            X
                        </SpanBotaoClose>
                    </DivTitulo>
                    <DivMainHorariosLivres>
                        {MontaGridHorarios(horariosLivres)}
                    </DivMainHorariosLivres>
                </DivMainPopupHorarios>
            </PopupHorarios>
            <PopupHorarios mostraPopup={openPopupAgendamentoSucesso}>
                <DivMainAgendamentoSucesso>
                    <img
                        style={{ width: "300px" }}
                        src={imagemSucesso}
                        alt="sucess"
                    />
                    <PAgendamentoSucesso>
                        Seu agendamento foi feito com sucesso
                    </PAgendamentoSucesso>
                    <ButtonAgendamentoSucesso onClick={resetInformacoes}>
                        Fechar
                    </ButtonAgendamentoSucesso>
                </DivMainAgendamentoSucesso>
            </PopupHorarios>
        </DivMainHorarioAgendamentoTreinamento>
    );
}
